import { gql } from '@apollo/client'

export const MODIFY_ACCOMMODATION_FACILITIES_MUTATION = gql`
  mutation ModifyAccommodationFacilities(
    $selectedIDs: [String!]!
    $propertyCode: String!
  ) {
    saveAccommodationFacilities(
      selectedIDs: $selectedIDs
      propertyCode: $propertyCode
    ) {
      message
    }
  }
`
